/**
 * The mouse on the ground: the tile under it and the ring left where the player clicked to walk (a ground move's
 * reticle: passes/groundAim.ts).
 */
import { isSolid } from '@nine/shared';
import { ellipse } from '../drawKit';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'hoverTile',
  layer: 'ground',
  order: 230,
  draw({ g, world: w, iso, ox, oy, renderer: r }) {
    g.lineWidth = 1;
    if (!r.hoverClient) return;
    const [hx, hy] = r.screenToWorld(...r.hoverClient);
    const i = Math.floor(hx);
    const j = Math.floor(hy);
    if (isSolid(w.map, i, j)) return;
    // Outline the tile around its centre, whichever way the camera faces.
    const [sx, sy] = iso.proj(i + 0.5, j + 0.5);
    const x = sx + ox;
    const y = sy + oy - 8;
    g.strokeStyle = 'rgba(255,236,190,.3)';
    g.beginPath();
    g.moveTo(x, y + 0.5);
    g.lineTo(x + 16, y + 8.5);
    g.lineTo(x, y + 16.5);
    g.lineTo(x - 16, y + 8.5);
    g.closePath();
    g.stroke();
  },
});

registerRenderPass({
  id: 'clickMark',
  layer: 'ground',
  order: 250,
  draw({ g, world: w, ox, oy, renderer: r }) {
    g.lineWidth = 1;
    const c = r.clickMark;
    if (!c) return;
    const k = 1 - (w.time - c.t) / 0.5;
    if (k <= 0) r.clickMark = null;
    else {
      g.strokeStyle = `rgba(255,226,140,${k})`;
      ellipse(g, c.x + ox, c.y + oy, 4 + 8 * k, 2 + 4 * k);
      g.stroke();
    }
  },
});
